/**
 * A área útil do painel: qual tela desenha em cada rota. É o ÚNICO lugar que liga rota a tela.
 *
 * As rotas são as oito áreas do admin atual (`admin.html:1761-1768`), mais a ficha da cliente, que o
 * admin atual abre a partir da lista de clientes. Cada tela mora na própria pasta em `telas/`, e cada
 * pasta é território de uma frente de construção; este arquivo é do principal.
 */

// As telas, uma por área.
import { TelaArquivos } from './telas/arquivos/index.js';
import { TelaClientes } from './telas/clientes/index.js';
import { TelaCompromissos } from './telas/compromissos/index.js';
import { TelaDepoimentos } from './telas/depoimentos/index.js';
import { TelaFichaCliente } from './telas/ficha-cliente/index.js';
import { TelaFinanceiro } from './telas/financeiro/index.js';
import { TelaMatriz } from './telas/matriz/index.js';
import { TelaPainel } from './telas/painel/index.js';
import { TelaSistema } from './telas/sistema/index.js';
import { TelaVendas } from './telas/vendas/index.js';

// O prefixo da ficha: `/clientes/<id da cliente>`.
export const PREFIXO_FICHA = '/clientes/';

// A rota da ficha de uma cliente, para as telas não montarem o texto na mão.
export function rotaDaFicha(idCliente: string): string {
  return `${PREFIXO_FICHA}${encodeURIComponent(idCliente)}`;
}

/**
 * O filtro que veio na rota, como `/vendas?etapa=proposta_enviada`. É assim que um clique num gráfico
 * do Painel abre a área já recortada (regra de gráfico interativo). A tela lê com `filtroDaRota`.
 */
export function filtroDaRota(rota: string): URLSearchParams {
  const indice = rota.indexOf('?');
  return new URLSearchParams(indice === -1 ? '' : rota.slice(indice + 1));
}

export function AreaUtil({ rota }: { readonly rota: string }) {
  // O caminho sem o filtro decide a tela; o filtro fica para a tela ler.
  const caminho = rota.split('?')[0] ?? rota;
  // A ficha vem antes do `switch`, porque a rota dela carrega o id da cliente.
  if (caminho.startsWith(PREFIXO_FICHA)) {
    return <TelaFichaCliente idCliente={decodeURIComponent(caminho.slice(PREFIXO_FICHA.length))} />;
  }
  switch (caminho) {
    case '/painel':
      return <TelaPainel />;
    case '/compromissos':
      return <TelaCompromissos />;
    case '/clientes':
      return <TelaClientes />;
    case '/vendas':
      return <TelaVendas />;
    case '/matriz':
      return <TelaMatriz />;
    case '/depoimentos':
      return <TelaDepoimentos />;
    case '/financeiro':
      return <TelaFinanceiro />;
    case '/arquivos':
      return <TelaArquivos />;
    case '/sistema':
      return <TelaSistema />;
    // Rota desconhecida: nada é desenhado no lugar de uma tela que não existe.
    default:
      return null;
  }
}
